export default function HeroSection() {
  return (
    <section
      className="relative flex items-center justify-center min-h-[90vh] overflow-hidden"
      style={{ paddingTop: '72px', minHeight: '600px' }}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/home-hero.jpeg"
          alt="縁結び和はは - シニアカップルが公園を散歩する温かい写真"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          width={1920}
          height={1080}
        />
        <div
          className="absolute inset-0"
          style={{ background: 'rgba(74,55,40,0.45)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full content-width text-center px-4 md:px-6 py-8 md:py-16">
        <div className="animate-fadeIn">
          <p
            className="text-white/80 mb-3 tracking-widest"
            style={{ fontSize: 'clamp(11px, 1.8vw, 14px)', textShadow: '0 1px 4px rgba(0,0,0,0.4)', letterSpacing: '0.15em' }}
          >
            東京・関東のシニア婚活相談所
          </p>
          <h1
            className="text-white mb-4 md:mb-6"
            style={{
              fontSize: 'clamp(20px, 5vw, 36px)',
              textShadow: '0 2px 8px rgba(0,0,0,0.4)',
              lineHeight: '1.65',
            }}
          >
            人生は、何歳からでも楽しくできる。
            <br />
            <span style={{ color: '#f5d9b8' }}>「ひとりじゃない」</span>と思える未来へ。
          </h1>
          <p
            className="text-white/90 mb-8 md:mb-12 mx-auto max-w-xl"
            style={{ fontSize: 'clamp(13px, 2.5vw, 18px)', textShadow: '0 1px 4px rgba(0,0,0,0.4)', lineHeight: '1.9' }}
          >
            東京シニア婚活・60代・70代の成婚実績多数。
            <br />
            あなたに合ったペースで、
            <br />
            安心してパートナー探しをサポートいたします。
          </p>
        </div>
      </div>
    </section>
  );
}
